import { render } from "./ClientFooter.vue?vue&type=template&id=461eaafe&scoped=true"
import script from "./ClientFooter.vue?vue&type=script&lang=js"
export * from "./ClientFooter.vue?vue&type=script&lang=js"

import "./ClientFooter.vue?vue&type=style&index=0&id=461eaafe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461eaafe"]])

export default __exports__